<template>
  <div :class="{
          'container': true,
          'container-small': true,
          'container-expand': true,
          'bg-light2': !background
        }">

    <Alert v-if="logoutAlert === 'success'" type="info" :message="loginData.logoutMessage" />

    <div class="content-narrow">
      <AccentHeader
        :header="loginData.header"
        :underline="true"
        :uppercase="false"/>
      <p v-if="addon" class="text-xs form-addon">
        {{ loginData.addonText }}
      </p>
      <form
        action="#"
        method="post"
        @submit.prevent="sendLoginForm({ login, pass })"
      >
        <fieldset class="form-wrapper">
          <ul class="form-items">
            <li>
              <label for="login-name">
                {{ loginData.input.name }} <span class="accent">*</span>
              </label>
              <input
                type="text"
                name="login"
                id="login-name"
                v-model="login"
                @focus="clearErrors()"
                :placeholder="loginData.input.namePlaceholder" />
            </li>
            <li>
              <label for="login-pass">
                {{ loginData.input.password }} <span class="accent">*</span>
              </label>
              <input
                type="password"
                name="pass"
                id="login-pass"
                v-model="pass"
                @focus="clearErrors()"
                :placeholder="loginData.input.passPlaceholder" />
            </li>
          </ul>
          <button type="submit"
                  class="btn-full"
                  ref="formButton">
            <span class="text-s">{{ loginData.button }}</span>
          </button>
        </fieldset>
      </form>

      <div class="info text-xs">
        <template v-if="errors.length">
          <div class="alert alert-error">
            <h5 class="alert-title accent">
              {{ errorData.title }}
            </h5>
            <p class="alert-desc">
              <template v-for="error in errors">
                {{error.msg}}
              </template>
              {{ errorData.tryAgain }}
            </p>
          </div>
        </template>
        <template v-else>
          <p><span class="accent">*</span> {{ loginData.required }}</p>
          <p>{{ loginData.lostPass }}
            <a href="/request" class="accent">
              {{ loginData.lostPassLink }}
            </a>
          </p>
          <p v-if="loginData.registerLink">
            {{ loginData.registerText }}
            <router-link :to="{ name: 'register'}" class="accent">
              {{ loginData.registerLink }}
            </router-link>
          </p>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Alert from '@/components/Alert.vue'
import AccentHeader from '@/components/AccentHeader.vue'

export default {
  name: 'login',
  props: ['addon', 'background'],
  components: {
    Alert,
    AccentHeader
  },
  data: function () {
    return {
      logoutAlert: false,
      login: '',
      pass: '',
      errors: []
    }
  },
  methods: {
    ...mapActions([
      'sendLoginForm'
    ]),
    clearErrors () {
      this.errors = []
    },
    scrollToErrors () {
      let $btn = this.$refs.formButton
      if ($btn) {
        $btn.scrollIntoView()
      }
    }
  },
  computed: {
    ...mapGetters([
      'getloginErrors',
      'loginData',
      'errorData',
      'authToken',
      'apiPath'
    ])
  },
  watch: {
    apiPath (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.clearErrors()
      }
    },
    authToken (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.clearErrors()

        if (newVal && newVal.length) {
          this.errors = [{ msg: this.errorData.incorrectLogin }]
        }
      }
    },
    getloginErrors (newVal, oldVal) {
      this.clearErrors()

      if (newVal !== oldVal) {
        switch (newVal) {
          case 401:
            this.errors = [{ msg: this.errorData.incorrectLogin }]
            break
          case 404:
            this.errors = [{ msg: this.errorData.networkError }]
            break
          default:
            this.errors = []
        }
        this.scrollToErrors()
      }
    },
    '$route.query.logout' () {
      this.logoutAlert = false
    }
  },
  mounted () {
    this.logoutAlert = (this.$route.query.logout && this.$route.query.logout === 'success' ? this.$route.query.logout : false)
  }
}
</script>

<style scoped lang="scss">
.info {
  font-weight: 500;
  margin: $gap-md 0;

  @include screen('sm'){
    margin: $gap-xl 0;
  }

  p {
    margin: $gap-xs 0;
  } // END .info p;

  a {
    text-decoration: none;

    &:hover,&:focus {
      text-decoration: underline;
    }
  } // END .info a;
} // END .info;

</style>
